<template>
  <button
    :display="display"
    :mobile="mobile"
    :class="classList"
    type="button"
    @click="sidebarToggle"
  >
    <span class="navbar-toggler-icon" />
  </button>
</template>

<script>
import {
  sidebarCssClasses,
  validBreakpoints,
  checkBreakpoint,
} from "../../shared/classes";
import toggleClasses from "../../shared/toggle-classes";
import { togglePs } from "../../mixins/togglePs";

export default {
  name: "SidebarToggler",
  mixins: [togglePs],
  props: {
    defaultOpen: {
      type: Boolean,
      default: true,
    },
    display: {
      type: String,
      default: "lg",
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classList() {
      return ["navbar-toggler"];
    },
  },
  mounted() {
    this.toggle(this.defaultOpen);
  },
  methods: {
    toggle(force) {
      const [display, mobile] = [this.display, this.mobile];

      mobile
        ? (document.getElementsByClassName("eb-sidebar")[0].style[
            "z-index"
          ] = 1111)
        : (document.getElementsByClassName("eb-sidebar")[0].style[
            "z-index"
          ] = 10);
      let cssClass = sidebarCssClasses[0];
      if (!mobile && display && checkBreakpoint(display, validBreakpoints)) {
        cssClass = `sidebar-${display}-show`;
      }
      toggleClasses(cssClass, sidebarCssClasses, force);
    },
    sidebarToggle(e) {
      this.onClick();
      e.preventDefault();
      e.stopPropagation();
      this.toggle();
    },
    onClick() {
      this.sidebarMinimize();
      this.brandMinimize();
      // tslint:disable:no-console
    },
    sidebarMinimize() {
      const isMinimized = document.body.classList.toggle("sidebar-minimized");
      this.$emit("cui-sidebar-minimize", isMinimized);
      this.togglePs(!isMinimized);
    },
    brandMinimize() {
      document.body.classList.toggle("brand-minimized");
    },
  },
};
</script>
